module.exports = __webpack_public_path__ + "static/OptimScan-bd4fa2b392a2de3c686353f96ddb6b95.png";